// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"ad515fcd","239":"d6fd4504","667":"e2b78d17"}[chunkId] + ".chunk.js";
};